export const attributes_index = ['attributes.index']
export const attributes_create = ['attributes.create']
export const attributes_edit = ['attributes.edit']

export default [].concat(
    attributes_index,
    attributes_create,
    attributes_edit
)
